<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>OpenAI Setup</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    <blaze-copy-connector-config-env-button
      [coupledConnector]="(coupledConnector$ | async) || undefined"
      (copyConfiguration)="copyConfiguration($event)"
    />
    <button
      [disabled]="connectorForm.invalid || isLoading || !isChildValid()"
      (click)="saveConnector()"
      blazeBarButton="primary"
    >
      {{ saveButtonLabel }}
    </button>
  </ng-container>

  <div content class="dialog-content">
    <form class="form" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Name Your Connector</label>
        <input
          type="text"
          formControlName="connectorName"
          name="connectorName"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">API Key</label>
        <input
          type="text"
          formControlName="apiKey"
          name="apiKey"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <mat-slide-toggle
          class="bd-toggle w-fit"
          labelPosition="after"
          (change)="toggleUsDataResidency($event)"
          [checked]="host.value === usDataResidency"
          disableRipple
          blazeTooltip="Enable this if your API key belongs to an OpenAI project with US data residency."
          matTooltipPosition="right"
        >
          US Residency
        </mat-slide-toggle>
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label">Default Model</label>
        <input
          type="text"
          formControlName="defaultModel"
          name="defaultModel"
          class="bd-text-input tall w-full"
          [placeholder]="defaultModelPlaceholder"
        />
      </div>
    </form>
    <blaze-openai-connector-functions-container
      [customFunctions]="customFunctions"
      (functionsChanged)="updateCustomFunctions($event)"
      (isValid)="isChildValid.set($event)"
    />
  </div>
</blaze-panel>
